export default __webpack_public_path__ + "static/media/d368507a764682924d6a48631754c6b4.png";